class EvmRpcClient {
  constructor(baseUrl) {
    this.getBalanceBaseToken = async (address) => {
      return this.request(`/v1/chain/core/accounts/account/${address}/balance`);
    };
    if (!baseUrl) {
      throw new Error("Base URL for EVM rpc is required.");
    }
    this.baseUrl = baseUrl.replace(/\/$/, "");
  }
  async request(endpoint, options, params) {
    const url = new URL(`${this.baseUrl}${endpoint}`);
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        if (value !== void 0) {
          url.searchParams.append(key, value.toString());
        }
      });
    }
    const response = await fetch(url, {
      ...options ?? {},
      headers: {
        "Content-Type": "application/json",
        ...options?.headers || {}
      }
    });
    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`API Error: ${response.status} ${response.statusText} - ${errorText}`);
    }
    return response.json();
  }
}
export {
  EvmRpcClient
};
//# sourceMappingURL=EvmRpcClient.js.map
